import CONSTS from '../../constants/actions';

const initialState = {};

const permissionsReducer = (state, action) => {
  switch (action.status) {
    case 'success':
      return { ...action.data };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSTS.FETCH_PERMISSIONS:
      return permissionsReducer(state, action);
    default:
      return state;
  }
};
